export const NOTIFICATIONS_SET_UNREAD_NUMBER = 'notifications.set-unread-number';
export const NOTIFICATIONS_MARK_AS_READ = 'notifications.mark-as-read';
export const NOTIFICATIONS_TOGGLE_LIST = 'notifications.toggle-list';
export const NOTIFICATIONS_NEW_ONE_CREATED = 'notifications.new-notification-created';
